/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountDefaultInfoRequest model module.
 * @module model/AccountControllerDtoAccountDefaultInfoRequest
 * @version 1.0
 */
class AccountControllerDtoAccountDefaultInfoRequest {
    /**
     * Constructs a new <code>AccountControllerDtoAccountDefaultInfoRequest</code>.
     * @alias module:model/AccountControllerDtoAccountDefaultInfoRequest
     * @param accountNo {Number} 
     */
    constructor(accountNo) { 
        
        AccountControllerDtoAccountDefaultInfoRequest.initialize(this, accountNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, accountNo) { 
        obj['accountNo'] = accountNo;
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountDefaultInfoRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountDefaultInfoRequest} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountDefaultInfoRequest} The populated <code>AccountControllerDtoAccountDefaultInfoRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountDefaultInfoRequest();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountDefaultInfoRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountDefaultInfoRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AccountControllerDtoAccountDefaultInfoRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

AccountControllerDtoAccountDefaultInfoRequest.RequiredProperties = ["accountNo"];

/**
 * @member {Number} accountNo
 */
AccountControllerDtoAccountDefaultInfoRequest.prototype['accountNo'] = undefined;






export default AccountControllerDtoAccountDefaultInfoRequest;

